import React from 'react';
import './Finance.scss';
import MolLink from '../../Basepage/parts/Menu/MolLink';

interface SaldoauszugProp {
  data: any;
  apiBase: string;
}
interface SaldoauszugState {
  showPosition: number;
}

export default class Saldoauszug extends React.Component<
  SaldoauszugProp,
  SaldoauszugState
> {
  constructor(prop) {
    super(prop);
    this.state = { showPosition: 10 };
  }

  render(): React.ReactNode {
    let tage = Object.keys(this.props.data.transactions);

    let tageCount = tage.length;
    let showTage = tage.reverse().slice(0, this.state.showPosition);
    let rows: JSX.Element[] = [];

    let financeTd = (number, rowSpan) => {
      if (rowSpan > 0) {
        return (
          <td style={{ textAlign: 'right' }} rowSpan={rowSpan}>
            {new Intl.NumberFormat('de-DE', {
              style: 'currency',
              currency: 'EUR',
            }).format(number)}
          </td>
        );
      } else
        return (
          <td style={{ textAlign: 'right', verticalAlign: 'top' }}>
            {new Intl.NumberFormat('de-DE', {
              style: 'currency',
              currency: 'EUR',
            }).format(number)}
          </td>
        );
    };

    showTage.map((item, index) => {
      let dayTransction = this.props.data.transactions[item];
      let transactionsCount =
        dayTransction.rechnungen.length + dayTransction.zahlungen.length;

      for (let i = 0; i < transactionsCount; i++) {
        let isRechnung = i < dayTransction.rechnungen.length;
        let positionRefs = null;
        let positionRef = null;
        if (isRechnung) {
          if (dayTransction.rechnungen[i].mol_auftrag_position != null) {
            positionRefs = dayTransction.rechnungen[i].mol_auftrag_position;
          } else if (
            dayTransction.rechnungen[i].mol_auftrag_lieferung != null
          ) {
            positionRefs = dayTransction.rechnungen[i].mol_auftrag_lieferung;
          } else {
            positionRefs = dayTransction.rechnungen[i].mol_auftrag_reture;
          }
          positionRef = positionRefs.split(',')[0];
        }
        rows.push(
          <tr
            key={
              (isRechnung ? 'rechnung_' : 'zahlung_') +
              item +
              '_' +
              i +
              '_' +
              rows.length
            }
            className={
              'row ' +
              (index % 2 == 0 ? 'mod2' : '') +
              (i + 1 == transactionsCount ? ' last' : '')
            }
          >
            {i == 0 ? (
              <td rowSpan={transactionsCount} className="date">
                {item}
              </td>
            ) : null}
            {isRechnung ? (
              <>
                <td>
                  <a
                    href={
                      this.props.apiBase +
                      '/Download.php?type=rechnung&mol_auftrag_id=' +
                      positionRef +
                      '&filename=' +
                      dayTransction.rechnungen[i].rechnungsdatei
                    }
                    target="_blank"
                  >
                    {dayTransction.rechnungen[i].rechnung_typ} #
                    {dayTransction.rechnungen[i].mol_rechnung_id}
                  </a>
                </td>
                {financeTd(
                  dayTransction.rechnungen[i].betrag *
                    (dayTransction.rechnungen[i].rechnung_typ == 'Rechnung'
                      ? -1
                      : 1),
                  0,
                )}
              </>
            ) : (
              <>
                <td>
                  Zahlung{' '}
                  {dayTransction.zahlungen[i - dayTransction.rechnungen.length]
                    .kname != 'Vorkasse'
                    ? dayTransction.zahlungen[
                        i - dayTransction.rechnungen.length
                      ].kname
                    : ''}
                </td>
                {financeTd(
                  dayTransction.zahlungen[i - dayTransction.rechnungen.length]
                    .betrag,
                  0,
                )}
              </>
            )}
            {i == 0 ? financeTd(dayTransction.saldo, transactionsCount) : null}
          </tr>,
        );
      }
    });

    return (
      <div id="Saldoauszug">
        <div>
          <table>
            <thead>
              <tr>
                <th>Tag</th>
                <th>Transaktionen</th>
                <th>Betrag</th>
                <th>Tages end Saldo</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r_item, r_index) => r_item)}
              {tageCount > this.state.showPosition ? (
                <tr>
                  <td
                    colSpan={4}
                    style={{ textAlign: 'center', cursor: 'pointer' }}
                    onClick={() => {
                      let newShow = {
                        showPosition: this.state.showPosition + 10,
                      };

                      this.setState(newShow);
                    }}
                  >
                    … weitere Transaktionen
                  </td>
                </tr>
              ) : null}
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}
